import storeInfo from '../store'
import { Widget } from '../types'

export const getWidgets = () => (): Widget[] => {
  const { widgets } = storeInfo.store.getState()
  return widgets || []
}